import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";

type MultipleSelectCheckmarksProps = {
  data: { label: string; value: string; checked: boolean }[];
  values: string[];
  onChangeValues: Function;
  label: string;
  onOpen?: Function;
  preventUnckeck?: boolean;
  fullWidth?: boolean;
};
export default function MultipleSelectCheckmarks({
  data,
  values,
  onChangeValues,
  label,
  onOpen,
  preventUnckeck = false,
  fullWidth = false,
}: MultipleSelectCheckmarksProps) {
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const _value = event.target.value;
    onChangeValues(_value);
  };

  return (
    <FormControl sx={{ m: 0, width: fullWidth?"100%":300 }}>
      <InputLabel
        size="small"
        color="secondary"
        id="demo-multiple-checkbox-label"
      >
        <Typography>{label}</Typography>
      </InputLabel>
      <Select
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        multiple
        value={values}
        size="small"
        onChange={handleChange}
        color="secondary"
        input={<OutlinedInput color="secondary" label={label} />}
        renderValue={(selected) => {
          const labels: string[] = [];
          data.forEach((item) => {
            if (selected.includes(item.value)) {
              labels.push(item.label);
            }
          });
          return labels.join(", ");
        }}
        onOpen={() => (onOpen ? onOpen() : null)}
      >
        {data.map((item, index) => (
          <MenuItem
            key={index}
            value={item.value}
            disabled={
              preventUnckeck && values.indexOf(item.value) > -1 ? true : false
            }
          >
            <Checkbox
              size="small"
              color="secondary"
              checked={values.indexOf(item.value) > -1}
            />
            <ListItemText primary={<Typography>{item.label}</Typography>} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
